<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-toolbar class="md-success">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <hierarchy-menu></hierarchy-menu>
          </div>
        </div>
      </md-toolbar>
      <br />
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <h4 class="title" style="color:#FFFFFF">
              <md-icon>power</md-icon>
              <span
                v-if="selectedDevice.owner"
                class="pointer"
                @click="modalOpen(1)"
                :title="relay1.name"
              >{{relayNameFormat(relay1.name)}}</span>
              <span
                v-else
                class="pointer-normal"
                :title="relay1.name"
              >{{relayNameFormat(relay1.name)}}</span>
            </h4>
          </div>

          <p class="category">{{$lang.general.energy_relay}}</p>
          <h3 class="title">
            <animated-number
              :value="relay1.energy"
              :formatValue="energyImportFormat"
              :duration="1000"
            />
          </h3>

          <md-button
            class="toggle-button"
            :class="{'md-primary':relay1.state == true, 'md-danger':relay1.state == false}"
            :disabled="!deviceStatus()"
            @click="setRelay(1)"
          >
            <span v-if="!relay1.state">{{$lang.keys.turn_on}}</span>
            <span v-if="relay1.state">{{$lang.keys.turn_off}}</span>
          </md-button>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            {{$lang.general.last_change}} {{relay1.lastChange}}
          </div>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <h4 class="title" style="color:#FFFFFF">
              <md-icon>power</md-icon>
              <span
                v-if="selectedDevice.owner"
                class="pointer"
                @click="modalOpen(2)"
                :title="relay2.name"
              >{{relayNameFormat(relay2.name)}}</span>
              <span
                v-else
                class="pointer-normal"
                :title="relay2.name"
              >{{relayNameFormat(relay2.name)}}</span>
            </h4>
          </div>

          <p class="category">{{$lang.general.energy_relay}}</p>
          <h3 class="title">
            <animated-number
              :value="relay2.energy"
              :formatValue="energyImportFormat"
              :duration="1000"
            />
          </h3>

          <md-button
            class="toggle-button"
            :class="{'md-primary':relay2.state == true, 'md-danger':relay2.state == false}"
            :disabled="!deviceStatus()"
            @click="setRelay(2)"
          >
            <span v-if="!relay2.state">{{$lang.keys.turn_on}}</span>
            <span v-if="relay2.state">{{$lang.keys.turn_off}}</span>
          </md-button>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            {{$lang.general.last_change}} {{relay2.lastChange}}
          </div>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <h4 class="title" style="color:#FFFFFF">
              <md-icon>power</md-icon>
              <span
                v-if="selectedDevice.owner"
                class="pointer"
                @click="modalOpen(3)"
                :title="relay3.name"
              >{{relayNameFormat(relay3.name)}}</span>
              <span
                v-else
                class="pointer-normal"
                :title="relay3.name"
              >{{relayNameFormat(relay3.name)}}</span>
            </h4>
          </div>

          <p class="category">{{$lang.general.energy_relay}}</p>
          <h3 class="title">
            <animated-number
              :value="relay3.energy"
              :formatValue="energyImportFormat"
              :duration="1000"
            />
          </h3>

          <md-button
            class="toggle-button"
            :class="{'md-primary':relay3.state == true, 'md-danger':relay3.state == false}"
            :disabled="!deviceStatus()"
            @click="setRelay(3)"
          >
            <span v-if="!relay3.state">{{$lang.keys.turn_on}}</span>
            <span v-if="relay3.state">{{$lang.keys.turn_off}}</span>
          </md-button>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            {{$lang.general.last_change}} {{relay3.lastChange}}
          </div>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <h4 class="title" style="color:#FFFFFF">
              <md-icon>power</md-icon>
              <span
                v-if="selectedDevice.owner"
                class="pointer"
                @click="modalOpen(4)"
                :title="relay4.name"
              >{{relayNameFormat(relay4.name)}}</span>
              <span
                v-else
                class="pointer-normal"
                :title="relay4.name"
              >{{relayNameFormat(relay4.name)}}</span>
            </h4>
          </div>

          <p class="category">{{$lang.general.energy_relay}}</p>
          <h3 class="title">
            <animated-number
              :value="relay4.energy"
              :formatValue="energyImportFormat"
              :duration="1000"
            />
          </h3>

          <md-button
            class="toggle-button"
            :class="{'md-primary':relay4.state == true, 'md-danger':relay4.state == false}"
            :disabled="!deviceStatus()"
            @click="setRelay(4)"
          >
            <span v-if="!relay4.state">{{$lang.keys.turn_on}}</span>
            <span v-if="relay4.state">{{$lang.keys.turn_off}}</span>
          </md-button>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            {{$lang.general.last_change}} {{relay4.lastChange}}
          </div>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-size-80">
      <global-sales-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.locations}}</h4>
        </template>

        <template slot="content">
          <devices-stats-panel :settings="devicesStatsData"></devices-stats-panel>
          <!-- <div id="map"></div> -->
        </template>
      </global-sales-card>
    </div>

    <div class="md-layout-item md-size-20">
      <global-sales-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>share</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.share}}</h4>
        </template>

        <template slot="content">
         <qr-code :text="qrcode"></qr-code>
        </template>
      </global-sales-card>
    </div>

    <modal v-if="showModal" @close="modalClose()">
      <template slot="header">
        <h4 class="modal-title">{{modalData.header}}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="modalClose()"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field :class="[{ 'md-error': errors.has('RELAY_NAME') }]">
              <label>{{$lang.general.name}}</label>
              <md-input
                v-model="modalData.name"
                data-vv-name="RELAY_NAME"
                type="text"
                name="RELAY_NAME"
                v-validate="modelValidations.relay_name"
                ref="RELAY_NAME"
                maxlength="32"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('RELAY_NAME')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>
        <br />
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field :class="[{ 'md-error': errors.has('RELAY_POWER') }]">
              <label>{{$lang.charts.active_power}}</label>
              <md-input
                v-model="modalData.power"
                data-vv-name="RELAY_POWER"
                type="text"
                name="RELAY_POWER"
                v-validate="modelValidations.relay_power"
                @keyup.enter="modalSave()"
                :disabled="!deviceStatus()"
              ></md-input>
              <span class="md-suffix">W</span>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('RELAY_POWER')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>
        <br />
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="modalSave()">{{$lang.keys.save}}</md-button>
        <md-button
          class="md-danger"
          @click="modalDeleteEnergy()"
          :disabled="!deviceStatus()"
        >{{$lang.keys.delete_energy}}</md-button>
        <md-button class="md-simple" @click="modalClose()">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/utils/gmaps";
import { Modal } from "@/components";
import snackBar from "@/components/SnackBar";
import hierarchyMenu from "@/components/HierarchyMenu";
import AnimatedNumber from "animated-number-vue";
import axios from "axios";
import { getSelectedDeviceToken, getUserToken } from "@/storage/memoryStorage";
import format from "date-fns/format";
import { StatsCard, GlobalSalesCard } from "@/components";

import DevicesStatsPanel from "@/components/Dashboard/DevicesStatsPanel";

import { SlideYDownTransition } from "vue2-transitions";
import CryptoJS from 'crypto-js';

export default {
  components: {
    "hierarchy-menu": hierarchyMenu,
    "snack-bar": snackBar,
    Modal,
    AnimatedNumber,
    StatsCard,
    GlobalSalesCard,
    DevicesStatsPanel,
    SlideYDownTransition
  },

  data() {
    return {
      modelValidations: {
        relay_name: {
          required: true,
          max: 30,
          min: 3
        },
        relay_power: {
          required: true,
          max_value: 99999,
          min_value: 0
        }
      },
      modalData: {},
      showModal: false,
      locations: [],
      devicesStatsData: [],
      switch1: true,
      relay1: {
        name: "",
        state: null,
        energy: 0,
        power: 0,
        lastChange: null
      },
      relay2: {
        name: "",
        state: null,
        energy: 0,
        power: 0,
        lastChange: null
      },
      relay3: {
        name: "",
        state: null,
        energy: 0,
        power: 0,
        lastChange: null
      },
      relay4: {
        name: "",
        state: null,
        energy: 0,
        power: 0,
        lastChange: null
      },
       qrcode: ""
    };
  },

  computed: {
    WSmessage() {
      return this.$store.getters.getDataMessage;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  watch: {
    WSmessage: function(payload, oldPayload) {
      this.relay1.state = payload.relay_1;
      this.relay2.state = payload.relay_2;
      this.relay3.state = payload.relay_3;
      this.relay4.state = payload.relay_4;

      if (payload.energy) {
        this.relay1.energy = payload.energy.R1;
        this.relay2.energy = payload.energy.R2;
        this.relay3.energy = payload.energy.R3;
        this.relay4.energy = payload.energy.R4;
      }
    },
    selectedDevice: function(newDevice, oldDevice) {
      this.getQRString();
      if (newDevice.mac !== oldDevice.mac) {
        this.getNameData();
        this.getRelaysStatistics();
        this.getPowerData();
        

        this.relay1.state = null;
        this.relay2.state = null;
        this.relay3.state = null;
        this.relay4.state = null;

        this.relay1.energy = 0;
        this.relay2.energy = 0;
        this.relay3.energy = 0;
        this.relay4.energy = 0;
      }
    }
  },

  created() {
    this.getQRString();
    this.getHierarchyData();
    this.getNameData();
    this.getRelaysStatistics();
    this.getPowerData();
    
  },

  methods: {
    deviceStatus() {
      try {
        const deviceListIndex = this.deviceList.findIndex(
          e => e.mac == this.selectedDevice.mac
        );
        if (this.deviceList[deviceListIndex].status === "ONLINE") {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    modalOpen(relay) {
      this.modalData.header = this.$lang.charts.relay + " " + relay;
      this.modalData.relayID = relay;
      this.modalData.name = this["relay" + relay].name;
      this.modalData.power = this["relay" + relay].power;
      this.showModal = true;

      this.$nextTick(() => {
        this.$refs.RELAY_NAME.$el.focus();
      });
    },

    modalClose() {
      this.showModal = false;
    },

    modalSave() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this["relay" + this.modalData.relayID].name = this.modalData.name;
          this["relay" + this.modalData.relayID].power = this.modalData.power;

          let postData = {
            token: getSelectedDeviceToken(this.selectedDevice.mac),
            names: {
              R1: this.relay1.name,
              R2: this.relay2.name,
              R3: this.relay3.name,
              R4: this.relay4.name
            }
          };

          if (this.deviceStatus()) {
            postData.power = {
              R1: this.relay1.power,
              R2: this.relay2.power,
              R3: this.relay3.power,
              R4: this.relay4.power
            };
          }

          axios({
            method: "POST",
            url: this.$ENDPOINTS.API_W + "/disconnector/settings",
            data: postData,
            withCredentials: true
          })
            .then(response => {})
            .catch(error => {
              if (error.response) {
                this.$refs.snackbar.notify(
                  this.$lang.messages.api_communication_error
                );
              }
            });

          this.modalClose();
        }
      });
    },

    modalDeleteEnergy() {
      let postData = {
        token: getSelectedDeviceToken(this.selectedDevice.mac),
        clear_energy: {}
      };

      postData.clear_energy["R" + this.modalData.relayID] = true;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/disconnector/settings",
        data: postData,
        withCredentials: true
      })
        .then(response => {
          this.$refs.snackbar.notify(this.$lang.messages.delete_energy_succes);
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });

      this.modalClose();
    },

    setRelay(relay) {
      let data = {
        token: getSelectedDeviceToken(this.selectedDevice.mac)
      };

      switch (relay) {
        case 1:
          data.relay_1 = !this.relay1.state;
          break;
        case 2:
          data.relay_2 = !this.relay2.state;
          break;
        case 3:
          data.relay_3 = !this.relay3.state;
          break;
        case 4:
          data.relay_4 = !this.relay4.state;
          break;
      }

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/disconnector/set-relay",
        data: data,
        withCredentials: true
      })
        .then(response => {})
        .catch(error => {
          if (error.response) {
          }
        });
    },

    getHierarchyData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/facility/devices-hierarchy",
        data: {
          token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.tags.forEach(element => {
            if (
              element.hasOwnProperty("lat") &&
              element.hasOwnProperty("lng")
            ) {
              const deviceListIndex = this.deviceList.findIndex(
                e => e.mac == element.mac
              );

              const mapMarker = {
                position: {
                  lat: Number(element.lat),
                  lng: Number(element.lng)
                },
                data: {
                  title: element.title,
                  tag: element.tags[0],
                  mac: element.mac,
                  status: this.deviceList[deviceListIndex].status
                }
              };

              this.locations.push(mapMarker);
            }
            if (element.tags.length > 0) {
              this.devicesStatsData.push(element.tags[0]);
            }
          });
          //this.initMap();
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code != 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
          //this.initMap();
        });
    },

    getNameData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          names: true
        },
        withCredentials: true
      })
        .then(response => {
          this.relay1.name = response.data.data.R1.name;
          this.relay2.name = response.data.data.R2.name;
          this.relay3.name = response.data.data.R3.name;
          this.relay4.name = response.data.data.R4.name;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              this.relay1.name = this.$lang.charts.relay + " 1";
              this.relay2.name = this.$lang.charts.relay + " 2";
              this.relay3.name = this.$lang.charts.relay + " 3";
              this.relay4.name = this.$lang.charts.relay + " 4";
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    getPowerData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          power: true
        },
        withCredentials: true
      })
        .then(response => {
          this.relay1.power = response.data.data.R1.power;
          this.relay2.power = response.data.data.R2.power;
          this.relay3.power = response.data.data.R3.power;
          this.relay4.power = response.data.data.R4.power;
        })
        .catch(error => {
          if (error.response) {
            //DEVICE IS OFFLINE
            if (error.response.data.code === 604) {
              this.relay1.power = 0;
              this.relay2.power = 0;
              this.relay3.power = 0;
              this.relay4.power = 0;
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    getRelaysStatistics() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/statistics",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          milliseconds: true
        },
        withCredentials: true
      })
        .then(response => {
          this.relay1.lastChange = format(
            response.data.data.RELAY_1.timestamp,
            "HH:mm:ss DD/MM/YYYY"
          );
          this.relay2.lastChange = format(
            response.data.data.RELAY_2.timestamp,
            "HH:mm:ss DD/MM/YYYY"
          );
          this.relay3.lastChange = format(
            response.data.data.RELAY_3.timestamp,
            "HH:mm:ss DD/MM/YYYY"
          );
          this.relay4.lastChange = format(
            response.data.data.RELAY_4.timestamp,
            "HH:mm:ss DD/MM/YYYY"
          );
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    relayNameFormat(name) {
      if (name.length > 12) {
        return name.slice(0, 12) + "...";
      }
      return name;
    },

    energyImportFormat(value) {
      if (value > 100000) {
        return `${Number(value / 1000).toFixed(2)} kWh`;
      } else {
        return `${Number(value).toFixed(2)} Wh`;
      }
    },

    getQRString(){

      let axiosConfig = {
        method: "POST",
        data: {
          deviceMAC: this.selectedDevice.mac,
          token: getUserToken(),
          name: this.selectedDevice.title,
          encode: true
        },
        withCredentials: true,
        url: this.$ENDPOINTS.API_R + "/qrtoken"
      };
      
      axios(axiosConfig).then(response => {
        
          if (response.data.status === "OK") 
          {
            this.qrcode = response.data.data.token;
          }
        })
        .catch(error => {
         
          if (error.response.data.status == "FAIL")
          {
            this.$refs.snackbar.notify(this.$lang.messages.api_communication_error+ " QR");
          }
        });

    }



    // async initMap() {
    //   try {
    //     const google = await gmapsInit();
    //     const geocoder = new google.maps.Geocoder();
    //     const map = new google.maps.Map(document.getElementById("map"), {
    //       gestureHandling: "cooperative"
    //     });

    //     function placeMarkerAndPanTo(latLng, map) {
    //       var marker = new google.maps.Marker({
    //         position: latLng,
    //         map: map
    //       });
    //       map.panTo(latLng);
    //     }

    //     geocoder.geocode({ address: `Slovakia` }, (results, status) => {
    //       if (status !== `OK` || !results[0]) {
    //         throw new Error(status);
    //       }

    //       map.setCenter(results[0].geometry.location);
    //       map.fitBounds(results[0].geometry.viewport);
    //     });

    //     /*        adding tag by click
    //      map.addListener("click", function(e) {
    //       placeMarkerAndPanTo(e.latLng, map);
    //     }); */

    //     const markerClickHandler = marker => {
    //       map.setZoom(18);
    //       map.setCenter(marker.getPosition());

    //       var contentString =
    //         '<div id="content">' +
    //         '<div id="siteNotice">' +
    //         "</div>" +
    //         '<h4 id="firstHeading" class="firstHeading">' +
    //         marker.data.title +
    //         "</h4>" +
    //         '<div id="bodyContent">' +
    //         this.$lang.general.device +
    //         ": " +
    //         marker.data.tag +
    //         "</br>" +
    //         "MAC: " +
    //         marker.data.mac +
    //         "</br>" +
    //         this.$lang.general.status +
    //         ": " +
    //         marker.data.status +
    //         "</br>" +
    //         "</div>" +
    //         "</div>";

    //       var infowindow = new google.maps.InfoWindow({
    //         content: contentString
    //       });

    //       infowindow.open(map, marker);
    //     };

    //     const markers = this.locations.map(location => {
    //       const marker = new google.maps.Marker({ ...location, map });
    //       marker.addListener(`click`, () => markerClickHandler(marker));

    //       return marker;
    //     });

    //     /*       new MarkerClusterer(map, markers, {
    //     imagePath: `https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m`,
    //   }); */
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }
  }
};
</script>

<style scoped>
#map {
  margin: 0;
  max-height: 500px;
}

.normal-header {
  padding: 0 !important;
  min-height: 0px;
}

/* .md-button.md-simple i,
.md-button.md-simple:hover i {
  color: #ffffff !important;
} */

.md-toolbar {
  position: inherit;
}

.modal-header {
  opacity: 1;
}

.stats-layout {
  justify-content: center;
  text-align: center;
}

.stats-title {
  margin-top: -20px;
}

.card-title {
  margin: 10px;
}

.modal-body {
  padding: 0px 0px 16px;
}

.modal-body p {
  margin: 5px;
}

.md-card [class*="md-card-header-"] .card-text {
  float: left;
}

.md-card-stats .md-card-header.md-card-header-icon i {
  font-size: 26px !important;
  line-height: 56px;
  width: 20px;
  height: 40px;
  text-align: center;
}

.toggle-button {
  margin-top: 20px;
}

.pointer {
  cursor: pointer;
}

.pointer-normal {
  cursor: context-menu;
}
</style>
